import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

type SignedIndicatorProps = {
  className?: string;
};

export const SignedIndicator = ({ className = "" }: SignedIndicatorProps) => {
  const { t } = useTranslation("terms");

  return (
    <span
      className={`inline-flex items-center gap-1 text-xs text-muted-foreground ${className}`.trim()}
    >
      <ShieldCheck className="h-3.5 w-3.5 text-green-600" />
      {t("signedIndicator.digitallySigned", { defaultValue: "Assinado digitalmente" })}
    </span>
  );
};
